import {
  AVAILABLE_BRAND_FEATURES,
  BookingAvailabilityModeValue,
} from '@kouto/types';
import { ReducerState } from 'types/reducer';
import { useAppState } from 'AppProvider';
import { useTranslation } from 'react-i18next';
import { getCurrencyFromCode, currencyFormat } from 'utils';
import { isFeatureActive } from 'utils/featureFlag';

interface PriceDisplayProps {
  advertisedPrice?: number | null;
  bookingAvailabilityMode?: BookingAvailabilityModeValue | null;
  maxParticipants?: number | null;
  startingPrice?: number | null;
}

const usePriceDisplay = ({
  advertisedPrice,
  bookingAvailabilityMode,
  maxParticipants,
  startingPrice,
}: PriceDisplayProps) => {
  const { t } = useTranslation();
  const { settings } = useAppState((state: ReducerState) => state.brand);
  const currency = getCurrencyFromCode(settings.currency);
  const showAdvertisedPrice =
    isFeatureActive(AVAILABLE_BRAND_FEATURES.ENABLE_SHOW_ADVERTISED_AMOUNT) &&
    advertisedPrice != null;
  const basePrice = showAdvertisedPrice ? advertisedPrice : startingPrice;
  const pricing =
    bookingAvailabilityMode === 'private'
      ? (basePrice || 0) * (maxParticipants || 0)
      : basePrice || 0;

  const displayedPrice =
    pricing > 0 ? currencyFormat(currency)(pricing) : t('complimentary');

  return displayedPrice;
};

export default usePriceDisplay;
